import { styled } from "@mui/styles";
import { useTheme } from "@mui/material/styles";

const CustomIconRoot = styled('span')(
  ({ resetDefaultContainerStyles, containerStyles }) => ({
    ...(!containerStyles && {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      alignSelf: 'center',
      ...(resetDefaultContainerStyles && {
        display: 'inline-block',
        lineHeight: 0,
      }),
    }),
    ...containerStyles,
  })
);

export default function CustomIcon({ icon: IconComponent = null, color = 'primary', iconSx = {}, containerStyles = null, resetDefaultContainerStyles = false, ...rest }) {
  const theme = useTheme();
  if (!IconComponent) return null;

  const colorSplit = color?.split('.') || []; // ['text', 'secondary']

  // Função para acessar o objeto dinamicamente
  const getValue = (obj, pathArr) =>
    pathArr.reduce((acc, key) => acc?.[key], obj);

  const colorValue = getValue(theme.palette, colorSplit);

  // resolve cores do tema
  const resolvedColor = colorValue || theme.palette[color]?.main || theme.palette.text[color] || color;

  const sx = {
    '&&.MuiSvgIcon-root path, && path': {
      fill: `${resolvedColor} !important`,
      color: `${resolvedColor} !important`,
    },
    ...iconSx,
  };

  return (
    <CustomIconRoot id="custom-icon-root" className="custom-icon-root" resetDefaultContainerStyles={resetDefaultContainerStyles} containerStyles={containerStyles}>
      <IconComponent
        sx={sx}
        {...rest}
      />
    </CustomIconRoot>
  );
}